export default {
  path: '/download',
  component: () => import(/* webpackChunkName: 'layout' */'@/views/download/layout/index'),
  meta: { requiresAuth: true },
  children: [
    {
      path: '/',
      name: 'download',
      component: () => import(/* webpackChunkName: 'download' */'@/views/download/index')
    }
  ]
};
